


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { MobileGetter, ExperimentGetter } from 'frontend/types';
import { throttle } from 'frontend/utils/timing';
import { safeWindow } from 'frontend/utils/window';
import LoginButton from 'frontend/components/header/LoginButton.vue';
import SignupButton from 'frontend/components/header/SignupButton.vue';

interface AxIds {
  headerLogInBtn: string;
  stickyHeaderLogInBtn: string;
  stickyHeaderSignUpBtn: string;
}

interface AxParams {
  ids: AxIds;
  extra?: object;
}

@Component({
  components: {
    LoginButton,
    SignupButton,
  },
  computed: {
    ...mapState('sponsorModalInfo', ['percent_off', 'sponsor_fans_name', 'promotion_name']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('globals', ['isAuthenticated']),
  },
})
export default class LandingHeaderV2 extends Vue {
  @Prop({ type: Object, required: true }) readonly axParams!: AxParams;
  @Prop({ type: Boolean, required: false }) readonly isMathcounts!: boolean;
  private isMobile!: MobileGetter;
  private showHeader = false;
  private isAuthenticated!: boolean;

  private get mobile() {
    return this.isMobile(this.$mq);
  }

  private get scrollHandler() {
    return throttle(() => {
      this.showHeaderOnScroll();
    }, 16);
  }

  private showHeaderOnScroll() {
    if (window.scrollY > 200) {
      this.showHeader = true;
    } else if (window.scrollY < 80) {
      this.showHeader = false;
    }
  }

  private mounted() {
    this.scrollHandler();
    safeWindow()?.addEventListener('scroll', this.scrollHandler);
  }

  private destroyed() {
    safeWindow()?.removeEventListener('scroll', this.scrollHandler);
  }
}
